import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_ZH_HANS } from 'material-react-table/locales/zh-Hans';

export const TABLE_LOCALE = {
  'en-US': MRT_Localization_EN,
  'ja-JP': MRT_Localization_JA,
  'zh-CN': MRT_Localization_ZH_HANS,
};

export const TABLE_TYPE = {
  HISTORY: 'history',
  KENSHIN: 'kenshin',
  KENSHIN_ASSIGNMENT: 'kenshin_assignment',
  BILLING: 'billing',
  WAGES: 'wages',
};

export const TABLE_STATE_KEYS = {
  // History
  HISTORY_PAGINATION: 'history_pagination',
  HISTORY_END_DATE: 'history_end_date',
  HISTORY_SORTING: 'history_sorting',
  HISTORY_START_DATE: 'history_start_date',

  // Kenshin
  KENSHIN_PAGINATION: 'kensin_pagination',
  KENSHIN_SORTING: 'kensin_sorting',
  KENSHIN_START_DATE: 'kenshin_start_date',
  KENSHIN_END_DATE: 'kenshin_end_date',

  // Billing
  BILLING_START_DATE: 'billing_start_date',
  BILLING_END_DATE: 'billing_end_date',
  BILLING_PAGINATION: 'billing_pagination',
  BILLING_SORTING: 'billing_sorting',
  // Wages
  WAGES_START_DATE: 'wages_start_date',
  WAGES_END_DATE: 'wages_end_date',
  WAGES_PAGINATION: 'wages_pagination',
  WAGES_SORTING: 'wages_sorting',

  // Kenshin Assignment
  KENSHIN_ASSIGNMENT_START_DATE: 'kenshin_assignment_start_date',
  KENSHIN_ASSIGNMENT_END_DATE: 'kenshin_assignment_end_date',
  KENSHIN_ASSIGNMENT_PAGINATION: 'kenshin_assignment_pagination',
  KENSHIN_ASSIGNMENT_SORTING: 'kenshin_assignment_sorting',
};
